// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_b9I","cls2":"PackPreviewRows-cls2_FJ2 PackPreviewRows-cls1_b9I"};